import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';

import { COOKIE_KEY } from 'src/api';
import { WEB_API_URL } from 'src/helpers/globals';

export const httpApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: WEB_API_URL,
    prepareHeaders: (headers: Headers) => {
      headers.set('Access-Control-Allow-Credentials', 'true');
      headers.set('Accept', 'application/json');
      headers.set('Content-Type', 'application/json');
      const cookieKey = Cookies.get(COOKIE_KEY);
      if (cookieKey) {
        headers.set('X-CSRF-Token', cookieKey);
      }
    },
  }),
  endpoints: (builder) => ({
    trackLead: builder.query({
      query: (trackingKeywords: string) => `/track/${trackingKeywords}`,
    }),
  }),
});

export const { useTrackLeadQuery } = httpApi;
